import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import RoleFormLayer from "../components/RoleFormLayer";

const RoleFormPage = () => {
  return (
    <MasterLayout>
      <RoleFormLayer />
    </MasterLayout>
  );
};

export default RoleFormPage;
